import { HttpClient } from '@angular/common/http';
import {  inject } from "@angular/core";
import { Observable } from 'rxjs';
import { AppDataService } from './app-data.service';
import { AuditTrailGroupedMasterRecord } from '../../shared/business-component/audit-trail/audit-trail.model';



export abstract class BaseService {

    
    public get apiURL(): string {
        return `${this.appDataService.configurations.rootApiUrl}/api${this.subUrl}`;
    }
     
    public get absoluteHostNameURL(): string {
        return this.appDataService.configurations.rootUrl;
    }

    public readonly idsURL: string | null = null;

    protected http: HttpClient = inject(HttpClient);
    protected appDataService: AppDataService= inject(AppDataService);
    
    constructor(protected subUrl: string = "") {}


    public request<T>(apiName: string, body?: object, method: string = "post", rootUrl: string = this.apiURL,options = {}, allowBusinessErrorToaster: string = 'allow'): Observable<T> {

        const headers = {
            ...(options as { headers: Record<string, string> })?.headers,
            'allow-business-error-toaster': allowBusinessErrorToaster,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        return this.http.request<T>(method, `${rootUrl}/${apiName}`, {
            ...options, body: body, headers: headers
        });
    }

    public requestBlob<T>(
        apiName: string,
        body?: object,
        method: string = "post",
        options = {},
        allowBusinessErrorToaster: string = 'allow',
        responseType: 'blob' = 'blob'  
    ): Observable<T> {

        const headers = {
            ...(options as { headers: Record<string, string> })?.headers,
            'allow-business-error-toaster': allowBusinessErrorToaster,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        return this.http.request<T>(method, `${this.apiURL}/${apiName}`, {
            ...options,
            body: body,
            headers: headers,
            responseType: responseType as any // cast because HttpClient is strongly typed on responseType
        });
    }
 

    public requestbyUrl<T>(url: string , body?: object, method: string = "post", options = {}, allowBusinessErrorToaster: string = 'allow'): Observable<T> {

        const header = { ...(options as { headers: object })?.headers, 'allow-business-error-toaster': allowBusinessErrorToaster, }
        return this.http.request<T>(method, `${this.appDataService.configurations.rootApiUrl}/api/${url}`, {
            ...options, body: body, headers: header
        });

    }    

    public post<T>(body: object, options = {}): Observable<T> {
        return this.http.post<T>(this.apiURL, body, options);
    }

    public save<T>(body: object, options = {}): Observable<T> {
        return this.http.post<T>(`${this.apiURL}/Save`, body, options);
    }

    public delete(id: string | number): Observable<any> {
        return this.http.delete<any>(`${this.apiURL}/Delete`, { body: { data: id } });
    }

    public get(body = {}): Observable<any> {
        return this.http.post<any>(`${this.apiURL}/Get`, body);
    }
    
    public getAuditGroups(id: number): Observable<AuditTrailGroupedMasterRecord[]> {
        return this.http.get<AuditTrailGroupedMasterRecord[]>(`${this.apiURL}/GetAudit?id=${id}`, {});
    }
}
